import { api } from './apiClient';

export interface EInvoiceDocument {
  id: number;
  invoice_id: number;
  status: 'DRAFT' | 'VALIDATED' | 'READY' | 'SUBMITTED' | 'FAILED' | 'CANCELLED';
  mode: 'DEMO' | 'SANDBOX' | 'LIVE';
  irn: string | null;
  ack_no: string | null;
  ack_date: string | null;
  request_json: any;
  response_json: any;
  error_message: string | null;
}

export interface EWayBill {
  id: number;
  invoice_id: number | null;
  status: string;
  mode: string;
  ewb_no: string | null;
  transporter: string | null;
  vehicle_no: string | null;
  transport_mode: string;
  distance_km: number | null;
  valid_from: string | null;
  valid_until: string | null;
  response_json: any;
}

export const eInvoiceService = {
  get: (invoiceId: number): Promise<{ eInvoice: EInvoiceDocument | null; eWayBill: EWayBill | null }> =>
    api.get(`/einvoice/invoice/${invoiceId}`),
  preview: (invoiceId: number): Promise<{ payload: any; errors: string[] }> =>
    api.get(`/einvoice/invoice/${invoiceId}/preview`),
  validate: (invoiceId: number): Promise<{ status: string; payload: any; errors: string[]; eInvoice: EInvoiceDocument | null }> =>
    api.post(`/einvoice/invoice/${invoiceId}/validate`),
  submit: (invoiceId: number): Promise<{ eInvoice: EInvoiceDocument | null }> =>
    api.post(`/einvoice/invoice/${invoiceId}/submit`),
  generateEWay: (invoiceId: number, data: { transporter?: string; vehicleNo?: string; transportMode?: string; distanceKm?: number }): Promise<{ eWayBill: EWayBill }> =>
    api.post(`/einvoice/invoice/${invoiceId}/eway`, data),
};

export default eInvoiceService;
